import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';

import { LocalStorageService } from '../../../shared/services/local-storage/local-storage.service';
import { STORAGE_ENUM } from '../../enums/storage.enum';
import { AuthService } from '../../services/auth/auth.service';

export const isAuthGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authService = inject(AuthService);
  const localStorageService = inject(LocalStorageService);

  const token = localStorageService.get(STORAGE_ENUM.TOKEN);

  if (token) {
    authService.verifyToken(token).subscribe({
      next: (response) => {
        router.navigate(['/']);
        return true;
      },
      error: (error) => {
        localStorageService.remove(STORAGE_ENUM.TOKEN);
        localStorageService.remove(STORAGE_ENUM.CUSTOMER);
        localStorageService.remove(STORAGE_ENUM.USER);
        localStorageService.remove(STORAGE_ENUM.PORTAL_USER_ID);

        return true;
      }
    });
  }

  return true;
};
